import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n/I18nContext";
import { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Register() {
  const { t } = useI18n();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("A palavra-passe deve ter pelo menos 8 caracteres.");
      return;
    }
    setLoading(true);
    try {
      const data = await register(name, email, password);
      if (data?.verification_link) {
        toast.message(t("email_not_connected"), { description: data.verification_link, duration: 10000 });
      }
      navigate("/onboarding");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F4F8FC]">
      <div className="w-full max-w-sm df-rise">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <h2 className="font-head text-2xl font-bold text-[#0D253F]">{t("register_title")}</h2>
        <p className="text-[#627D98] mt-1 mb-6">{t("register_sub")}</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>{t("name")}</Label><Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" /></div>
          <div><Label>{t("email")}</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" /></div>
          <div><Label>{t("password")}</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="register-password" /></div>
          <Button type="submit" disabled={loading} className="w-full h-12 bg-[#1A73E8] hover:bg-[#1557B0] text-white font-semibold" data-testid="register-submit">
            {loading ? t("loading") : t("register")}
          </Button>
        </form>
        <p className="text-center mt-4 text-sm text-[#627D98]">{t("have_account")} <Link to="/login" className="text-[#1A73E8] font-semibold" data-testid="to-login">{t("login")}</Link></p>
      </div>
    </div>
  );
}
